import React from "react";
import PropTypes from "prop-types";
import { CLIENT_SEARCH_FILTERS } from "../constants/clientSearchFilters";

const DropDownField = ({
  ReceivedTextData,
  classDiv,
  label,
  bold,
  length,
  id,
  value,
  color,
  disabled,
  options,
  requiredMsg,
}) => {
  const AlterTextField = (e) => {
    ReceivedTextData.call(undefined, {
      fieldName: e.target.name,
      fieldValue: e.target.value,
      optionLabel: `${e.target.name}_text`,
      optionLabelValue: e.target[e.target.selectedIndex].label,
      event: e,
    });
  };


  const GetColor = (healthValue) => {
    const result = CLIENT_SEARCH_FILTERS.HEALTH_SCORE_OPTIONS.find((item) => item.value === healthValue);
    return result?.color
  }

  return (
    <>
      <div className={classDiv === true ? "field-container" : ""}>
        {label !== false && (
          <label className={`field-placeholder ${bold === true ? "font-medium" : ""}`}>
            {label}
          </label>
        )}
        <select
          className="field-input pt-1"
          maxLength={length}
          name={id}
          value={value}
          style={{
            backgroundColor: value && id === "healthScore" || id === "Health_Score" ? GetColor(value) : "white",
          }}
          disabled={disabled || false}
          id={id}
          onChange={AlterTextField}
        >
          {options.length > 0 &&
            options.map((item, key) => (
              <option
                key={key}
                style={item.color ? { backgroundColor: item.color } : null}
                value={item.value}
              >
                {item.label}
              </option>
            ))}
        </select>
      </div>
      {requiredMsg && value.length < 1 && (
        <label className="requiredtext">Required</label>
      )}
    </>
  );
};

DropDownField.propTypes = {
  ReceivedTextData: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
  // requiredMsg: PropTypes.string.isRequired,
};

export default DropDownField;
